import useAdOpenRTBSignal from '~/composables/useAdOpenRTBSignal';
import { useAdTargetingArticle } from '~/composables/useAdTargetingArticle';
import { useAdTargetingCategoryPage } from '~/composables/useAdTargetingCategoryPage';
import { useAdTargetingFrontpage } from '~/composables/useAdTargetingFrontpage';
import { useAdTargetingTagPage } from '~/composables/useAdTargetingTagPage';

export default defineNuxtPlugin((nuxt) => {
  window.lwhb = window.lwhb || { cmd: [] };
  window.googletag = window.googletag || { cmd: [] };

  const oneId = getOneId();
  if (oneId) {
    window.googletag.cmd.push(() => {
      window.googletag.pubads().setPublisherProvidedId(oneId);
      window.googletag.enableServices();
    });
  }

  nuxt.hook('cpp:data:loaded', ({ type, name }: { type: string; name?: string }) => {
    useAdOpenRTBSignal(type);

    const retargetingSegments = getRetargetingSegments();
    if (retargetingSegments.length) {
      window.googletag.cmd.push(() => {
        window.googletag.pubads().setTargeting('retargeting_segment', retargetingSegments);
      });
    }

    switch (type) {
      case 'article': {
        const { host, article: articleAdConfig } = getAdConfig();
        useAdTargetingArticle(host, articleAdConfig);
        break;
      }
      case 'frontpage': {
        useAdTargetingFrontpage();
        break;
      }
      case 'tagpage': {
        if (name) {
          useAdTargetingTagPage(name);
        }
        break;
      }
      case 'sectionpage':
      case 'latestpage':
      case 'searchpage':
      case 'categorypage': {
        if (name) {
          useAdTargetingCategoryPage(name);
        }
        break;
      }
    }
  });
});
